import { Seo } from '../components/Seo';
import React, { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import { DealCard } from '../components/OfferCards';
import { AffiliateDisclosure } from '../components/AffiliateDisclosure';
import { api } from '../lib/api';
import { useApp } from '../context/AppContext';
import { openDeal } from '../lib/deals';
import { Tag } from 'lucide-react';

export default function Deals() {
  const { currency } = useApp();
  const [data, setData] = useState(null);
  const [category, setCategory] = useState('');
  const [scope, setScope] = useState('');

  const load = (cat, sc) => api.deals({ category: cat, scope: sc }).then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load('', ''); }, []);

  return (
    <Layout>
      <Seo title="Today's Best Travel Deals" path="/deals"
        description="Handpicked flight, hotel and experience deals updated regularly on FlightDeals.in. Compare and book with trusted partners — no booking fees." />
      <section className="bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="font-display text-3xl font-semibold flex items-center gap-2"><Tag className="h-7 w-7 text-accent" /> Travel deals</h1>
          <p className="text-primary-foreground/75 mt-1">Handpicked fares & offers across flights, hotels and experiences.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-wrap gap-2 mb-3">
          {['', ...(data?.categories || [])].map((c) => (
            <button key={c || 'all'} onClick={() => { setCategory(c); load(c, scope); }}
              className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${category === c ? 'bg-accent/12 text-accent border-accent/30' : 'bg-card text-muted-foreground border-border hover:bg-secondary'}`}
              data-testid={`deal-category-${(c || 'all').toLowerCase().replace(/ /g, '-')}`}>{c || 'All categories'}</button>
          ))}
        </div>
        <div className="flex flex-wrap gap-2 mb-5">
          {['', ...(data?.scopes || [])].map((s) => (
            <button key={s || 'anyscope'} onClick={() => { setScope(s); load(category, s); }}
              className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${scope === s ? 'bg-primary text-primary-foreground border-primary' : 'bg-card text-muted-foreground border-border hover:bg-secondary'}`}
              data-testid={`deal-scope-${(s || 'any').toLowerCase().replace(/ /g, '-')}`}>{s || 'Any'}</button>
          ))}
        </div>
        <div className="mb-4"><AffiliateDisclosure variant="banner" /></div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="deals-list">
          {data?.deals?.map((d) => <DealCard key={d.id} deal={d} currency={currency} onViewDeal={(deal) => openDeal({ type: deal.type, offer: deal, surface: 'deals_page', source: '/deals' })} />)}
        </div>
        {data?.deals?.length === 0 && <p className="text-center py-16 text-muted-foreground">No deals in this category yet.</p>}
        <p className="mt-6 text-xs text-muted-foreground">Prices are indicative and provided by partners. We don’t claim any deal is the cheapest in the market.</p>
      </section>
    </Layout>
  );
}
